/** Shared filter-chip & pill state classes — single source of truth for hover/selected styles. */

/* ---- Text chip base (category & format bodies) ---- */
export const TEXT_CHIP_BASE = 'border rounded-input py-3 px-5 text-center font-inter text-sm leading-normal cursor-pointer select-none outline-none transition-[color,background-color,border-color,transform] ease-in-out active:scale-95 focus-visible:border-brand-yellow';

/* ---- Chip state (icon chips & text chips) ---- */
export const CHIP_UNSELECTED = 'border-dinnerplate-white bg-off-white text-grey hover:bg-dinnerplate-white-lighter hover:border-grey-light';
export const CHIP_SELECTED = 'border-off-black bg-off-white text-off-black hover:bg-dinnerplate-white-light';

/* ---- Pill state (nutrition & temperature tags) ---- */
export const PILL_UNSELECTED = 'border-dinnerplate-white bg-off-white text-grey hover:bg-dinnerplate-white-lighter hover:border-grey-light';
export const PILL_SELECTED = 'border-off-black bg-off-white text-off-black hover:bg-dinnerplate-white-light';
